module.exports = __webpack_public_path__ + "static/pexels-frank-meriño-3612023-68244c8f2055ee2991600b031cf282da.jpg";